import React, {useEffect, useReducer} from "react"
import {useSelector} from 'react-redux';
import MessPopUpAction from './MessPopUpAction';
import AccountAction from '../../actions/AccountAction';
import CommonUtil from "../../common/CommonUtil";
import {translate} from "react-i18next";
import cookie from "react-cookies";

const displayMessPopUp = cookie.load('displayMessPopUp') || false;

const MessPopUpComponent = (props) => {
  const totalMessage = useSelector(state => state.AccountsSlice.totalMessage);
  const isPa = CommonUtil.isPA();
  const [state, setState] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      messageSubject: '', 
      messageText: '',
      messageImgSrc: ''
    }
  );
  const lang = CommonUtil.getCurrentLang() || 'en';

  useEffect(() => {
    if (totalMessage >= 0 && !displayMessPopUp && !isPa) {
      if (totalMessage > 0) {
        fetchData();
      }
      CommonUtil.saveCookie("displayMessPopUp", true, { path: "/", domain: AccountAction.getSubDomain()});
    }
  }, [totalMessage]);

  useEffect(() => {
    const classList = document.getElementsByTagName("body")[0].classList;
    state.messageText ? classList.add("tc-modal-open") : classList.remove("tc-modal-open");
  }, [state.messageText]);

  const fetchData = () => {
    MessPopUpAction.getLastMessShowAtLogin().then(response => {
      if (response && response.message) {
        setState({
          messageSubject: response.message.subject,
          messageText: response.message.text,
          messageImgSrc: response.message.imgSrc
        })
      }
    })
  }

  const close = () => {
    setState({
      messageSubject: '',
      messageText: '',
      messageImgSrc: ''
    });
  }

  const viewMore = () => {
    window.open(`/${lang}/account/messages`, 'messages', 'width=1150,height=800,resizable=yes');
    setState({
      messageSubject: '',
      messageText: '',
      messageImgSrc: ''
    });
  }

  const renderHeaderContent = () => {
    return (
      <div className="header-popup">
        <div className="content-title">
          <p className="content-text" title= {state.messageSubject}>{state.messageSubject}</p>
          <i className="fa fa-times" aria-hidden="true" title="Close"
            onClick={() => close()}></i>
        </div>
      </div>
    )
  }
  
  const renderMessContent = () => {
    return (
      <div className="item">
        {renderHeaderContent()}
        <div className="content-item">
          <div className="content-link" dangerouslySetInnerHTML={{ __html: state.messageText }}></div>
          {
            window.env.newMessPopupEnabled && state.messageImgSrc &&
            <img className='content-img' src={`${state.messageImgSrc}`} alt='' onClick={() => CommonUtil.openImageNewTab(state.messageImgSrc)} />
          }
        </div>
        <div className="content-footer">
          <button className="mess-button" onClick={close}>{props.t('OK')}</button>
          <a className="remind" onClick={viewMore}>{props.t('View More Messages')}</a>
        </div>
      </div>
    )
  }

  return ( state.messageText && state.messageSubject && (
    <React.Fragment>
      <div className="terms-conditions show">
        <div className="tc-dialog-modal">
          <div className={`mess-dialog s-dialog no-select ${window.env.newMessPopupEnabled ? 'new-mess-dialog' : ''}`}>
            <div className="mess-content">
              {renderMessContent()}
            </div>
          </div>
        </div>
      </div>
      <div className="tc-dialog-overlay overlay"></div>
    </React.Fragment>
  ))
}
export default translate()(React.memo(MessPopUpComponent));



// WEBPACK FOOTER //
// ./src/app/components/MessPopUpComponent/index.js